/* Durnev — collection-card colour swatch click → swap card image.
   Each .durnev-coll-card__swatch button carries data-card-image (URL of
   the variant's featured image for that colour). Click swaps the
   .durnev-coll-card__img src and toggles --active state on swatches.
   Works for both pre-rendered cards and any cards added to the DOM
   later (e.g. via durnev-coll-infinite.js).

   On page load we PRE-WARM the browser cache for every swatch's
   data-card-image so that subsequent clicks swap instantly without a
   network round-trip. Initial card images are already loaded eagerly
   (Shopify default) so the visible state is unaffected; we just front-
   load the off-card variant images at low priority.

   Hover preview is intentionally skipped — clicks are explicit and
   match user expectations from product page; hover would feel jumpy on
   wide grids. */
(function () {
  var SWATCH_SEL = '.durnev-coll-card__swatch[data-card-image], .durnev-card__swatch[data-card-image]';
  var SWATCH_ANY_SEL = '.durnev-coll-card__swatch, .durnev-card__swatch';
  var CARD_SEL = '.durnev-coll-card, .durnev-card';
  var IMG_SEL = '.durnev-coll-card__img, .durnev-card__img';

  function preloadAll() {
    var seen = {};
    document.querySelectorAll(SWATCH_SEL).forEach(function (sw) {
      var url = sw.getAttribute('data-card-image');
      if (!url || seen[url]) return;
      seen[url] = true;
      var im = new Image();
      im.decoding = 'async';
      im.fetchPriority = 'low';
      im.src = url;
    });
  }
  // Sync prices PROMPTLY (not idle) so there's no visible price flash on the
  // first paint; pre-warm images on idle since that's heavier, less urgent.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncActivePrices(); }, { once: true });
    document.addEventListener('DOMContentLoaded', preloadAll, { once: true });
  } else {
    syncActivePrices();
    // DOM already parsed — schedule image pre-warm on next idle tick so we
    // don't fight the initial paint for bandwidth.
    if (window.requestIdleCallback) {
      requestIdleCallback(preloadAll, { timeout: 1500 });
    } else {
      setTimeout(preloadAll, 600);
    }
  }
  // After infinite scroll injects new cards: sync their prices + pre-warm
  // images. Idle is fine here — injected cards are below the fold while the
  // user scrolls, so a brief delay before the price settles isn't visible.
  // syncActivePrices is flag-guarded, so its own writes don't loop the observer.
  var observer = new MutationObserver(function () {
    var cb = function () { syncActivePrices(); preloadAll(); };
    if (window.requestIdleCallback) requestIdleCallback(cb, { timeout: 2000 });
    else setTimeout(cb, 800);
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
  function findCard(el) {
    return el.closest(CARD_SEL);
  }

  // Rebuild the card price to the selected colour's price. Each swatch carries
  // data-card-price (+ data-card-compare when that colour is on sale), rendered
  // server-side with the SAME money filter as the static price, so the swapped
  // string matches exactly. The two card types use different price-class names,
  // so branch on which one we're in. A sold-out card keeps РОЗПРОДАНО.
  function applyCardPrice(card, sw) {
    var price = sw.getAttribute('data-card-price');
    if (!price) return; // swatch without price data (e.g. placeholder) → leave as-is
    var coll = card.classList.contains('durnev-coll-card');
    var box = card.querySelector(coll ? '.durnev-coll-card__price' : '.durnev-card__price');
    if (!box) return;
    if (box.querySelector('.durnev-coll-card__price-soldout, .durnev-card__price-soldout')) return;
    var cmp = sw.getAttribute('data-card-compare');
    if (coll) {
      box.innerHTML = cmp
        ? '<span class="durnev-coll-card__price-old">' + cmp + '</span><span class="durnev-coll-card__price-now durnev-coll-card__price-now--sale">' + price + '</span>'
        : '<span class="durnev-coll-card__price-now">' + price + '</span>';
    } else {
      box.innerHTML = cmp
        ? '<span class="durnev-card__price-old">' + cmp + '</span><span class="durnev-card__price-new">' + price + '</span>'
        : '<span class="durnev-card__price-regular">' + price + '</span>';
    }
  }

  // Make the price match the pre-selected (active) swatch on load and for any
  // cards injected by infinite scroll, so the highlighted colour and the price
  // never disagree. One-shot flag per card so the innerHTML writes below don't
  // re-trigger the MutationObserver into a loop.
  function syncActivePrices(root) {
    (root || document).querySelectorAll(CARD_SEL).forEach(function (card) {
      if (card.hasAttribute('data-price-synced')) return;
      card.setAttribute('data-price-synced', '1');
      var active = card.querySelector('.durnev-coll-card__swatch--active[data-card-price], .durnev-card__swatch--active[data-card-price]');
      if (active) applyCardPrice(card, active);
    });
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest(SWATCH_ANY_SEL);
    if (!sw) return;
    var card = findCard(sw);
    if (!card) return;

    // Don't trigger anchor navigation when the swatch is inside <a>.
    e.preventDefault();
    e.stopPropagation();

    var newSrc = sw.getAttribute('data-card-image');
    if (!newSrc) return;

    var img = card.querySelector(IMG_SEL);
    if (img && img.src !== newSrc) {
      img.src = newSrc;
      img.removeAttribute('srcset');
    }

    // Toggle active state on swatches (move 28px ring + 1px inset frame).
    // Each card type uses its own --active modifier class.
    card.querySelectorAll(SWATCH_ANY_SEL).forEach(function (s) {
      var isActive = s === sw;
      if (s.classList.contains('durnev-coll-card__swatch')) {
        s.classList.toggle('durnev-coll-card__swatch--active', isActive);
      } else {
        s.classList.toggle('durnev-card__swatch--active', isActive);
      }
    });

    // Update the visible price to the chosen colour (matches the PDP).
    applyCardPrice(card, sw);
  }, true);  // capture so we run before <a> click navigates
})();
